import { getTvObject, tv } from '@costar-ui/cosmos';
import spacingOptions from '../../../common/space-options/spacing-options.esm.js';

var radioGroupTv = getTvObject({
  base: ['flex', 'gap-1'],
  variants: {
    alignment: {
      horizontal: '',
      vertical: 'flex-col'
    },
    gap: spacingOptions.gap
  }
});
var radioGroupStyles = tv(radioGroupTv);

export { radioGroupStyles, radioGroupTv };
//# sourceMappingURL=radio-group.styles.esm.js.map
